<template>
  <div
    class="w-full h-full px-7 py-16 md:px-36 md:py-16 over-scroll padding-container"
  >
    <div>
      <p
        @click="changeInfo('people')"
        class="text-lg cursor-pointer px-12"
        :class="infoVisible !== 'people' ? 'text-submenu' : 'text-color'"
      >
        {{ $t("about") }}
      </p>
      <div v-if="infoVisible == 'people'">
        <div class="pt-4">
          <p v-if="studioVisible === 'studio'" class="text-sm md:text-base">
            {{ $t("aboutText") }}
          </p>
        </div>
      </div>
    </div>

    <div>
      <p
        @click="changeInfo('practice')"
        class="text-lg cursor-pointer px-12"
        :class="[
          infoVisible !== 'practice' ? 'text-submenu' : 'text-color',
          infoVisible === 'people' ? 'pt-4' : '',
        ]"
      >
        {{ $t("experience") }}
      </p>
      <div v-if="infoVisible == 'practice'">
        <div class="pt-4 w-full" v-if="practiceVisible === 'scena'">
          <div>
            <div class="md:flex justify-between">
              <p class="text-sm md:text-base">
                {{ $t("webDeveloper") }} Units x Educar
              </p>
              <p class="text-sm md:text-base">{{ $t("june") }} 2024</p>
            </div>
            <p class="text-xs md:text-sm text-zinc-500">
              {{ $t("exUnits") }}
            </p>
          </div>
          <div class="pt-4 md:pt-2">
            <div class="md:flex justify-between">
              <p class="text-sm md:text-base">{{ $t("prBroomx") }}</p>
              <p class="text-sm md:text-base">
                {{ $t("february") }} 2024 - {{ $t("june") }} 2024
              </p>
            </div>
            <p class="text-xs md:text-sm text-zinc-500">
              {{ $t("exBroomx") }}
            </p>
          </div>
          <div class="pt-4 md:pt-2">
            <div class="md:flex justify-between">
              <p class="text-sm md:text-base">
                {{ $t("membre") }} Playful Living Lab
              </p>
              <p class="text-sm md:text-base">
                {{ $t("september") }} 2023 - {{ $t("june") }} 2024
              </p>
            </div>
            <p class="text-xs md:text-sm text-zinc-500">
              {{ $t("exLab") }}
            </p>
          </div>
          <div class="pt-4 md:pt-2">
            <div class="md:flex justify-between">
              <p class="text-sm md:text-base">{{ $t("coCreator") }} Wildtech</p>
              <p class="text-sm md:text-base">
                {{ $t("september") }} 2023 - {{ $t("june") }} 2024
              </p>
            </div>
            <p class="text-xs md:text-sm text-zinc-500">
              {{ $t("exWildtech") }}
            </p>
          </div>
          <div class="pt-4 md:pt-2">
            <div class="md:flex justify-between">
              <p class="text-sm md:text-base">
                {{ $t("coCreator") }} Mural “El Modern”
              </p>
              <p class="text-sm md:text-base">
                {{ $t("january") }} 2023 - {{ $t("march") }} 2023
              </p>
            </div>
            <p class="text-xs md:text-sm text-zinc-500">
              {{ $t("exModern") }}
            </p>
          </div>
          <div class="pt-4 md:pt-2">
            <div class="md:flex justify-between">
              <p class="text-sm md:text-base">
                {{ $t("profesora") }} Workshop Wordpress
              </p>
              <p class="text-sm md:text-base">{{ $t("january") }} 2023</p>
            </div>
            <p class="text-xs md:text-sm text-zinc-500">
              {{ $t("exEram") }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div>
      <p
        @click="changeInfo('approaches')"
        class="text-lg cursor-pointer px-12"
        :class="[
          infoVisible !== 'approaches' ? 'text-submenu' : 'text-color',
          infoVisible === 'practice' ? 'pt-4' : '',
        ]"
      >
        {{ $t("skills") }}
      </p>
      <div v-if="infoVisible == 'approaches'">
        <div class="px-20">
          <p
            @click="approachesShow('sustainability')"
            :class="[
              'text-lg',
              'cursor-pointer',
              'text-submenu',
              approachesVisible !== 'sustainability'
                ? 'text-submenu'
                : 'text-color',
            ]"
          >
            {{ $t("software") }}
          </p>
          <p
            @click="approachesShow('pitching')"
            :class="[
              'text-lg',
              'cursor-pointer',
              'text-submenu',
              approachesVisible !== 'pitching' ? 'text-submenu' : 'text-color',
            ]"
          >
            {{ $t("webDevelopment") }}
          </p>
        </div>
        <div class="pt-4">
          <div v-if="approachesVisible === 'sustainability'">
            <div class="flex flex-wrap">
              <div class="justify-items-center p-4">
                <img
                  src="../../public/img/Figma.png"
                  alt=""
                  class="w-14 h-14"
                />
                <p class="text-center">Figma</p>
              </div>
              <div class="justify-items-center p-4">
                <img
                  src="../../public/img/Adobe_XD_CC_icon.svg.png"
                  alt=""
                  class="w-14 h-14"
                />
                <p class="text-center">XD</p>
              </div>
              <div class="justify-items-center p-4">
                <img
                  src="../../public/img/adobe-photoshop-logo-2.png"
                  alt=""
                  class="w-14 h-14"
                />
                <p class="text-center">Photoshop</p>
              </div>
              <div class="justify-items-center p-4">
                <img
                  src="../../public/img/Adobe_Illustrator_CC_icon.svg.png"
                  alt=""
                  class="w-14 h-14"
                />
                <p class="text-center">Illustrator</p>
              </div>
              <div class="justify-items-center p-4">
                <img
                  src="../../public/img/Adobe_InDesign_CC_icon.svg.png"
                  alt=""
                  class="w-14 h-14"
                />
                <p class="text-center">InDesign</p>
              </div>
              <div class="justify-items-center p-4">
                <img
                  src="../../public/img/Final_Cut_Pro_iPad.webp"
                  alt=""
                  class="w-14 h-14"
                />
                <p class="text-center">Final Cut</p>
              </div>
            </div>
          </div>
          <div
            v-if="approachesVisible === 'pitching'"
            class="w-full flex flex-col gap-4"
          >
            <p class="text-md underline">{{ $t("lenguagesProgramming") }}</p>
            <div class="flex flex-wrap gap-6 px-4">
              <div class="flex flex-col items-center">
                <div class="circle setanta">
                  <span>75%</span>
                </div>
                <p class="text-sm">HTML</p>
              </div>
              <div class="flex flex-col items-center">
                <div class="circle setanta">
                  <span>75%</span>
                </div>
                <p class="text-sm">CSS</p>
              </div>
              <div class="flex flex-col items-center">
                <div class="circle cinc">
                  <span>50%</span>
                </div>
                <p class="text-sm">JS</p>
              </div>
            </div>
            <p class="text-md underline">{{ $t("frames") }}</p>
            <div class="flex flex-wrap gap-6 px-4">
              <div class="flex flex-col items-center">
                <div class="circle cinc">
                  <span>50%</span>
                </div>
                <p class="text-sm">Vue.js</p>
              </div>
              <div class="flex flex-col items-center">
                <div class="circle trenta">
                  <span>35%</span>
                </div>
                <p class="text-sm">Svelte.js</p>
              </div>
              <div class="flex flex-col items-center">
                <div class="circle vint">
                  <span>25%</span>
                </div>
                <p class="text-sm">Node.js</p>
              </div>
              <div class="flex flex-col items-center">
                <div class="circle vint">
                  <span>25%</span>
                </div>
                <p class="text-sm">Socket.io</p>
              </div>
            </div>
            <p class="text-md underline">{{ $t("eines") }}</p>
            <div class="flex flex-wrap gap-6 px-4">
              <div class="flex flex-col items-center">
                <div class="circle sis">
                  <span>65%</span>
                </div>
                <p class="text-sm">Boostrap</p>
              </div>
              <div class="flex flex-col items-center">
                <div class="circle setanta">
                  <span>75%</span>
                </div>
                <p class="text-sm">Tailwind</p>
              </div>
              <div class="flex flex-col items-center">
                <div class="circle cinc">
                  <span>50%</span>
                </div>
                <p class="text-sm">GSAP</p>
              </div>
            </div>
            <div class="flex">
              <div class="">
                <p class="text-md underline">{{ $t("base") }}</p>
                <div class="flex p-4">
                  <div class="flex flex-col items-center">
                    <div class="circle quatre">
                      <span>40%</span>
                    </div>
                    <p class="text-sm">MongoDB</p>
                  </div>
                </div>
              </div>
              <div class="px-6">
                <p class="text-md underline">CMS</p>
                <div class="flex p-4">
                  <div class="flex flex-col items-center">
                    <div class="circle sis">
                      <span>65%</span>
                    </div>
                    <p class="text-sm">Wordpress</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <p
        @click="changeInfo('contact')"
        class="text-lg cursor-pointer px-12 pb-8"
        :class="infoVisible !== 'contact' ? 'text-submenu' : 'text-color'"
      >
        {{ $t("contact") }}
      </p>
      <div v-if="infoVisible == 'contact'">
        <p class="text-sm md:text-base">
          {{ $t("contactText") }}
          <u>nurianusan@gmail.com</u>
        </p>
        <p class="text-sm md:text-base pt-4">
          {{ $t("tmbContact") }}
          <a
            href="https://www.linkedin.com/in/núria-jordán-sánchez-3b5889120/"
            target="_blank"
            class="underline"
            >linkedin</a
          >
          {{ $t("tmbContact2") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      isVisible: false,
      infoVisible: "people",
      studioVisible: "studio",
      practiceVisible: "scena",
      approachesVisible: "sustainability",
    };
  },
  methods: {
    infoShow() {
      this.isVisible = !this.isVisible;
    },
    changeInfo(newValue) {
      this.infoVisible = newValue;
      console.log(this.infoVisible);
    },
    peopleShow(newValue) {
      this.studioVisible = newValue;
      console.log(this.studioVisible);
    },
    practiceShow(newValue) {
      this.practiceVisible = newValue;
      console.log(this.studioVisible);
    },
    approachesShow(newValue) {
      this.approachesVisible = newValue;
      console.log(this.approachesVisible);
    },
  },
};
</script>

<style>
@media (min-width: 640px) {
  .responsive-container {
    padding: 16px 36px;
  }
}

.circle {
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.setanta {
  background: conic-gradient(
    var(--text-color) 0deg 270deg,
    var(--graphic-color) 270deg 360deg
  );
}

.sis {
  background: conic-gradient(
    var(--text-color) 0deg 210deg,
    var(--graphic-color) 210deg 360deg
  );
}

.cinc {
  background: conic-gradient(
    var(--text-color) 0deg 180deg,
    var(--graphic-color) 180deg 360deg
  );
}

.quatre {
  background: conic-gradient(
    var(--text-color) 0deg 150deg,
    var(--graphic-color) 150deg 360deg
  );
}

.trenta {
  background: conic-gradient(
    var(--text-color) 0deg 100deg,
    var(--graphic-color) 100deg 360deg
  );
}

.vint {
  background: conic-gradient(
    var(--text-color) 0deg 80deg,
    var(--graphic-color) 80deg 360deg
  );
}

.circle::before {
  content: "";
  position: absolute;
  width: 40px;
  height: 40px;
  background: var(--background-color);
  border-radius: 50%;
}

.circle span {
  position: absolute;
  font-size: 12px;
  font-weight: bold;
  color: var(--text-color);
}

.text-submenu {
  color: var(--subtext-color);
}

.text-submenu:hover {
  color: var(--text-color);
}

.text-color {
  color: var(--text-color);
}
</style>